<template>
<div class="AmazonGoods">
  <full-con canReturn="1">
    <div slot="editBreadcrumb">
      <editBreadcrumb :pageTitle="$t('amazon.amazon09')"></editBreadcrumb>
    </div>
    <div slot="full">
      <div class="demo-form">
        <div class="demo-form-item">
          <span class="form-item-label">{{ $t('goods.goods2' || '商品名称') }}:</span>
          <el-input
            v-model="queryInfo.productName"
            :placeholder="$t('orderList.orderList3')"
            clearable
              size="small"
          />
        </div>
        <div class="demo-form-item">
          <span class="form-item-label">ASIN:</span>
          <el-input
            v-model="queryInfo.asin"
            :placeholder="$t('orderList.orderList3')"
            clearable
            size="small"
          />
        </div>
        <div class="demo-form-item">
          <span class="form-item-label">SKU:</span>
          <el-input
            v-model="queryInfo.fnSku"
            :placeholder="$t('orderList.orderList3')"
            clearable
            size="small"
          />
        </div>
        <div class="demo-form-item">
          <span class="form-item-label">{{ $t('wzbg.wz5' || '状态') }}:</span>
          <el-select
            v-model="queryInfo.status"
            clearable
            :placeholder="$t('common.pleaseSelect')"
            size="small"
          >
            <el-option
              v-for="item in feedbackType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <div class="demo-form-item">
          <span class="form-item-label">{{ $t('orderList.orderList153' || '可装箱') }}:</span>
          <el-select
            v-model="queryInfo.canApply"
            clearable
            :placeholder="$t('common.pleaseSelect')"
            size="small"
          >
            <el-option key="true" :label="$t('filter.filter37')" value="true"/>
            <el-option key="false" :label="$t('filter.filter36')" value="false"/>
          </el-select>
        </div>
        <div class="demo-form-btn">
          <el-button
              type="primary"
              size="small"
              class="ple-default-plain"
              @click="handleCurrentChange(1)"
          >{{ $t('common.search' || '搜索') }}</el-button>
          <el-button
              type="primary"
              size="small"
              plain
              @click="handleClear"
          >{{ $t('common.reset' || '重置') }}</el-button>
          <el-button
              type="success"
              size="small"
              class="ple-default-plain"
              @click="handleBatchPurchase"
              :disabled="selection.length <= 0"
          >{{ $t('amazon.amazon41' || '一键采购') }}</el-button>
          <el-button
              type="success"
              size="small"
              class="ple-default-plain"
              @click="handleBatchShipment"
              :disabled="selection.length <= 0"
          >{{ $t('amazon.amazon42' || '一键发货') }}</el-button>
          <el-button
              type="primary"
              size="small"
              class="ple-default-plain"
              @click="handleSyncOrder"
          >{{ $t('amazon.amazon25' || '手动同步') }}</el-button>
        </div>
      </div>
    </div>
    <div slot="full-two">
      <div class="table">
        <el-table
            :header-cell-style="tableStyle.headerStyle"
            :cell-style="tableStyle.cellStyle"
            :data="recordList"
            border
            :key="queryInfo.pageNum"
            class="zcl-css"
            height="calc(100vh - 280px)"
            style="width: 100%;height: calc(100vh - 280px)"
            :row-style="{height: '40px'}"
            highlight-current-row
            @selection-change="handleSelectionChange"
            :row-class-name="tableRowClassName"
        >
          <el-table-column type="selection" width="55" :selectable="selectable"></el-table-column>
          <el-table-column type="index" align="center" :label="$t('wzbg.wz6')" width="60"></el-table-column>
          <el-table-column prop="productName" min-width="180" align="center" :label="$t('goods.goods2' || '商品名称') ">
            <template v-slot="{row}">
              <el-tooltip popper-class="tooltip-haswidth" effect="light" placement="top-start" :content="row.productName">
                <div class="text-row-2" style="color: #409eff;cursor: pointer;" @click="handleClick(row)">{{row.productName}}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="productName" align="center" :label="$t('goods.goods20' || '商品图片') " width="120">
            <template v-slot="{row}">
              <img @click="imgclick(row.mainImage, true)" v-if="row.mainImage && row.mainImage.length > 0" :src="row.mainImage" alt="" class="list-image" />
            </template>
          </el-table-column>
          <el-table-column width="120" prop="asin" align="center" :label="'ASIN'">
          </el-table-column>
          <el-table-column width="120" prop="fnSku" align="center" :label="'SKU'">
          </el-table-column>

          <!--<el-table-column prop="typeDetail" align="center" :label="$t('amazon.amazon13' || '销售额')"></el-table-column>-->
          <el-table-column prop="fulfillableQuantity" width="100" align="center" :label="$t('amazon.amazon14' || '库存')"></el-table-column>
          <el-table-column prop="canApplyCount" align="center" width="100" :label="$t('fba.canBoxCount' || '可装箱数')"></el-table-column>
          <el-table-column prop="status" width="100" align="center" :label="$t('wzbg.wz5' || '状态')">
            <template v-slot="{row}">
              {{statusObj[row.status]}}
            </template>
          </el-table-column>

          <el-table-column width="120" prop="balance" align="center" :label="$t('handle')">
            <template v-slot="{row}">
              <el-button class="search-btn btn-blue" @click="setGoods(row)">{{ $t('amazon.amazon12' || '库存阈值') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryInfo.pageNum"
            :page-sizes="[5, 10, 20, 50, 100, 200]"
            :pager-count="5"
            :page-size="queryInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>
      </div>
      <!-- 新建装箱单 -->
      <packing-order ref="packing" @success="handleCurrentChange(1)" />
    </div>
  </full-con>

  <!--    图片放大-->
  <el-dialog title="" :visible.sync="visible" width="30%" show-close center>
    <img width="100%" height="auto" :src="imgurl" alt="" class="list-image" />
  </el-dialog>
</div>
</template>
<script>
import editBreadcrumb from "@/views/layout/components/editBreadCrumb.vue";
import FullCon from '@/views/FullContainer-2.vue'
import packingOrder from './components/packingOrder'

export default {
  name: "AmazonGoods",
  components: { editBreadcrumb, FullCon, packingOrder },
  data(){
    return {
      statusObj: {
        '0': this.$t('amazon.amazon24'),
        '1': this.$t('amazon.amazon23'),
      },
      feedbackType: [
        {
          value: '1',
          label: this.$t('amazon.amazon23')
        },
        {
          value: '0',
          label: this.$t('amazon.amazon24')
        }
      ],
      logisticeCompanyArr: [
        {
          value: 0,
          label: this.$t('user.status1')
        },
        {
          value: 1,
          label: this.$t('amazon.amazon22')
        }
      ],
      queryInfo: {
        sellingPartnerId:'',
        productName: '',
        asin: '',
        fnSku: '',
        status: '',
        isInventoryWarning: '',
        canApply: '',
        pageSize: 10,
        pageNum: 1,
      },
      recordList: [],
      total: 0,
      visible: false,
      imgurl: '',
      selection: []
    }
  },
  methods:{
    handleBatchPurchase(){
      let lastOrderList = this.selection.map(item => {
        let goodsCount = item.warningQuantity - item.fulfillableQuantity
        let orderList = item.orderIdList.split(',')
        return {
          lastOrderId:orderList[orderList.length -1],
          goodsCount:goodsCount > 0 ? goodsCount : 1
        }
      })
      this.replenishment(lastOrderList)
    },
    handleBatchShipment(){
      let orderIdList = []
      this.selection.map(item => {
        if (item.orderIdList != '') {
          let orderList = item.orderIdList.split(',')
          orderList.map(item => {
            orderIdList.push(Number(item))
          })
        }
      })
      console.log(orderIdList)
      this.$refs.packing.openPacking(orderIdList);
    },
    replenishment(lastOrderList){
      this.$http.post('aws/amazonInventory/replenishmentOrder',lastOrderList).then(res => {
        if(res.data.code === 200){
          this.$message({
            message: this.$t('success' || '操作成功'),
            type: 'success'
          });
        }
      })
    },
    handleSelectionChange(val) {
      this.selection = val;
    },
    imgclick (url) {
      this.visible = true
      this.imgurl = url
    },
    handleClick(row){
      window.open(`https://www.amazon.co.jp/gp/product/${row.asin}`)
    },
    tableRowClassName({row}) {
      return this.isWarning(row) ? 'warning-row' : ''
    },
    selectable(row){
      return row.orderIdList != ''
    },
    isWarning(row){
      if (
          (row.fulfillableQuantity || row.fulfillableQuantity === 0) &&
          (row.warningQuantity || row.warningQuantity === 0)
      ) {
        if(row.fulfillableQuantity < row.warningQuantity){
          return true;
        }
      }
      return false;
    },
    // 手动同步订单
    async handleSyncOrder(){
      const res = await this.$http.get('aws/amazonInventory/inventorySync',{params: {sellingPartnerId:this.queryInfo.sellingPartnerId}});
      if(res.data.code === 200){
        this.$message({
          message: this.$t('amazon.amazon26' || '数据正在加载中，请稍等。'),
          type: 'success'
        });
        await this.getrecordList()
      }
    },
    // 库存阈值
    setGoods (row) {
      this.$modalDialog(() => import('./components/setGoodsValue.vue'), {
        row,
      }).then(
          () => {
            this.getrecordList()
          },
          () => {
          }
      )
    },
    // 列表数据
    async getrecordList(){
      console.log(this.queryInfo);
      const { data: res } = await this.$http.get('aws/amazonInventory/inventoryPage', { params: this.queryInfo });
      console.log(res);
      this.recordList = res.data.list;
      this.total = res.data.total;
    },
    // 清除条件
    handleClear(){
      this.queryInfo.productName = '';
      this.queryInfo.asin = '';
      this.queryInfo.fnSku = '';
      this.queryInfo.isInventoryWarning = '';
      this.queryInfo.status = '';
      this.queryInfo.pageSize = 10;
      this.queryInfo.pageNum = 1;

      this.getrecordList()
    },
    handleSizeChange (newSize) {
      this.queryInfo.pageSize = newSize;
      this.getrecordList();
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pageNum = newPage;
      this.getrecordList();
    },
  },
  created () {
    this.queryInfo.sellingPartnerId = this.$route.query.sellingPartnerId;
    this.getrecordList();
  },
}
</script>
<style scoped lang="less">
.demo-form{
  display: flex;
  flex-wrap: wrap;
  .demo-form-item {
    display: flex;
    align-items: center;
    width: calc(20% - 10px);
    margin-right: 10px;
    margin-bottom: 10px;
    .form-item-label {
      white-space: nowrap;
      margin-right: 4px;
    }
  }
  .demo-form-item:nth-last-child(1 of .demo-form-item) {
    margin-right: 0;
    width: 20%;
  }
  .demo-form-btn {
    // flex: 1;
    width: 100%;
    text-align: right;
  }
}
.order-end {
  display: flex;
  justify-content: flex-end;
}
.search-btn {
  margin-right: 0 !important;
}
.AmazonGoods {
  ::v-deep(.el-table__body .warning-row td),
  ::v-deep(.el-table__body .warning-row:hover td) {
    background-color: #FFF7E6 !important;
  }
  ::v-deep(.el-table-column--selection){
    text-align: center;
  }
}
</style>
<style>
.tooltip-haswidth {
  max-width: 260px;
}
</style>
